import { render, staticRenderFns } from "@/modules/Agency/templates/agencies-list.html?vue&type=template&id=08ecf098&scoped=true&"
import script from "@/modules/Agency/scripts/agencies-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Agency/scripts/agencies-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Agency/styles/agencies-list.scss?vue&type=style&index=0&id=08ecf098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecf098",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
